import { useCallback } from 'react';
import { GetAuditLogsResponse } from '@uniqkey-backend-organization-web/api-client';
import { useApiClients } from '../../contexts/APIClientsContext';
import { TGetAuditLogsMethod } from './interfaces';
import {
  auditLogPayloadExtractor,
  dataExtractor,
} from '../../helpers/apiClients';

const useAuditLogsAPI = () => {
  const { auditLogsAPIClient } = useApiClients();

  const getAuditLogs = useCallback<TGetAuditLogsMethod>(
    (params, axiosRequestConfig) => {
      const {
        page,
        pageLength,
        onlySupporterLogs = undefined,
        employeeAccountId = undefined,
        beforeDate = undefined,
        afterDate = undefined,
      } = params;
      return auditLogsAPIClient
        .apiV1AuditLogsGet(
          page,
          pageLength,
          onlySupporterLogs,
          employeeAccountId,
          beforeDate,
          afterDate,
          axiosRequestConfig,
        )
        .then(dataExtractor<GetAuditLogsResponse>())
        .then((response) => ({
          ...response,
          data: response.data.map(((el) => auditLogPayloadExtractor(el))),
        }));
    },
    [auditLogsAPIClient],
  );

  return {
    getAuditLogs,
  };
};

export default useAuditLogsAPI;
